// DS: i1.2, DS1.7.6
import React from 'react';
import cn from 'classnames';
import s from './CoreSymbol.scss';
const CoreSymbol = ({ className, size, customSize, corePackage = 'generic', useSecondaryColor })=>{
    const classNames = cn(s['root'], useSecondaryColor ? s['secondary-color'] : s[corePackage === 'generic' ? 'core_generic' : corePackage], size && !customSize && s[`size-${size}`], customSize && s['custom-size'], className);
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames,
        style: customSize
    }, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 14 15"
    }, /*#__PURE__*/ React.createElement("path", {
        className: s['fill-color'],
        d: "M7 14.5a7 7 0 100-14 7 7 0 000 14z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M8.218 3.02l-.164.164-.78 1.496-.245.164H4.2V7.14h1.558l.123.164L4.2 10.522v1.68h1.68l.165-.184.779-1.496.246-.164h2.828V8.062H8.341l-.123-.164 1.68-3.218V3.02h-1.68z"
    })));
};
CoreSymbol.displayName = 'CoreSymbol';
export default CoreSymbol;
